import { get, patch, post } from '@/shared/utils/api-utils'

export const getOnboardingAccess = (orgId: string) =>
  get<{ canRunOnboarding: boolean }>(
    `/organizations/${orgId}/onboarding-access`
  )

export const updateOnboardingStep = (orgId: string, step: number) =>
  patch<void, { step: number }>(`/organizations/${orgId}/onboarding-step`, {
    step,
  })

export const completeOnboarding = (orgId: string) =>
  post<void, Record<string, never>>(
    `/organizations/${orgId}/complete-onboarding`,
    {}
  )
